import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteNavLinks } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-2 group">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50 tracking-wider group-hover:text-primary-400 transition-colors">
                黑料718
              </span>
            </Link>

            <div className="hidden md:flex items-center space-x-1">
              {siteNavLinks.main.map((link) => {
                const isActive = location.pathname === link.href;
                return (
                  <Link
                    key={link.href}
                    to={link.href}
                    className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                      isActive
                        ? 'text-primary-400 bg-primary-500/10'
                        : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                    }`}
                  >
                    {link.name}
                    {isActive && (
                      <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-6 h-0.5 bg-primary-500 rounded-full" />
                    )}
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full text-foreground-400 hover:text-foreground-100 hover:bg-background-100 transition-colors cursor-pointer">
              <i className="ri-search-line text-base"></i>
            </button>
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              APP下载
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-300 hover:text-foreground-100 transition-colors cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/60 py-4 space-y-1">
            {siteNavLinks.main.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`block px-4 py-3 text-sm rounded-lg transition-colors ${
                    isActive
                      ? 'text-primary-400 bg-primary-500/10 font-medium'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
            <div className="pt-3 px-4">
              <Link
                to="/about"
                className="block w-full text-center py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer"
              >
                APP下载
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}